import * as React from 'react';
import styled from 'styled-components';

import { ModuleImageBanner } from '@packages/common';
import { BaseImage } from '../BaseImage/BaseImage';

export type ImageBannerProps = ModuleImageBanner;

export const Image = styled(BaseImage)`
  display: block;
`;

export class ImageBanner extends React.PureComponent<ImageBannerProps> {
  render() {
    const image = { ...this.props.image, alt: this.props.image.alt || this.props.title, title: this.props.title };
    return <Image {...this.props} image={image} />;
  }
}
